var map = {
	"./agma2001-D04_fig08.png": "afe8",
	"./agma2001-D04_fig09.png": "48d8",
	"./agma2001-D04_fig10.png": "7ebe",
	"./agma2001-D04_fig11.png": "173b",
	"./agma2001-D04_fig12-1.png": "dffd",
	"./agma2001-D04_fig12-2.png": "0a4f",
	"./agma2001-D04_fig12-3.png": "9ec5",
	"./agma2001-D04_fig13.png": "01f5",
	"./agma2001-D04_fig14.png": "0e90",
	"./agma2001-D04_fig15.png": "9ef5",
	"./agma2001-D04_fig16.png": "42a3",
	"./agma2001-D04_fig17.png": "8e03",
	"./agma2001-D04_fig18.png": "5ca3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "09bb";